<template>
    <div
        class="tw-flex tw-flex-row tw-text-center tw-justify-center tw-items-center tw-gap-4"
    >
        <v-btn
            color="primary"
            fab
            small
            @click="decrement"
            :disabled="value <= minValue"
        >
            <v-icon>mdi-minus</v-icon>
        </v-btn>
        <div class="tw-font-bold tw-text-lg tw-text-center">
            {{ value }}
        </div>
        <v-btn
            color="primary"
            fab
            small
            @click="increment"
            :disabled="value >= maxValue"
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
    </div>
</template>
<script setup lang="ts">
import { computed, watch, toRef } from 'vue'

const props = defineProps<{
    value: number
    min?: number
    max?: number
}>()
const emit = defineEmits<{
    (e: 'input', value: number): void
}>()

const minValue = computed(() => {
    if (props.min || props.min === 0) return props.min

    return 0
})

const maxValue = computed(() => {
    if (props.max || props.max === 0) return props.max
    return Number.POSITIVE_INFINITY
})
const value = toRef(props, 'value')
watch(maxValue, (newValue) => {
    if (value.value > newValue) {
        emit('input', newValue)
    }
})

watch(minValue, (newValue) => {
    if (value.value < newValue) {
        emit('input', newValue)
    }
})
const increment = () => {
    emit('input', props.value + 1)
}

const decrement = () => {
    emit('input', props.value - 1)
}
</script>
